export default "__VITE_ASSET__D$ulLb7x__"